import { ColumnDetails } from '../../../../grid/types/common';
import { Column, ColumnKeys, DataGridItem } from '../types';
import { html, TemplateResult } from 'lit';
import { isEmpty } from '@nirvana/shared/basic-types/object';
import { dateFormatter } from '@nirvana/shared/time';
import { UNAVAILABLE_DATA } from '../../../types';

export function actionsRenderer(
  rowData: { item: DataGridItem },
): TemplateResult {
  return html` <span class="cell-label" style="display: flex; justify-content: flex-end">
    <gz-icon-button
      buttonFill="quiet"
      buttonColor="secondary"
      buttonType="no_hover"
      icon="ds-icon-cancel"
      size="24"
      fontSize="24"
      data-internal-id="${rowData.item.id}"
      @click="${this.onItemDelete.bind(this)}"
    ></gz-icon-button>
  </span>`;
}

export function dateRenderer(rowData: { item: DataGridItem }, columnDetails: ColumnDetails<any, any>): string {
  const cellValue = rowData.item[columnDetails.key];

  if (isEmpty(cellValue)) {
    return UNAVAILABLE_DATA;
  }

  return dateFormatter(cellValue, '');
}
